import { isEqual } from "lodash-es";
import { useEffect, useState } from "react";
import { useLocation, useRouteMatch } from "react-router";

/**
 * Retreives history state and avoids losing that state when child routes are rendered.
 */
export const useHistoryState = <T>(defaultValue: T): T => {
    const routeMatch = useRouteMatch();
    const location = useLocation<T>();
    const [t, setT] = useState(routeMatch.isExact ? location.state : defaultValue);

    useEffect(() => {
        const value = location.state ?? defaultValue;
        if (routeMatch.isExact && isEqual(value, t) === false) {
            setT(value);
        }
    }, [location.state, routeMatch.isExact, defaultValue, t]);

    return routeMatch.isExact ? (location.state ?? defaultValue) : t;
};
